import { type PermissionCodeTypes, useUserAccess } from '@register-ui/utils';
import type { ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

interface ProtectedViewProps {
    grantAccessIfAny?: boolean;
    accessList: PermissionCodeTypes[];
    children?: ReactNode;
    altView?: ReactNode;
}

export function ProtectedView({
    grantAccessIfAny = false,
    accessList,
    altView = null,
    children = <Outlet />,
}: Readonly<ProtectedViewProps>) {
    const { canAccess, isLoadingUser } = useUserAccess();

    if (isLoadingUser) {
        return null;
    }

    if (canAccess(accessList, grantAccessIfAny)) {
        return children;
    }

    return altView;
}
